import { render, staticRenderFns } from "./AaddNews.vue?vue&type=template&id=1c67ad5e&scoped=true&"
import script from "./AaddNews.vue?vue&type=script&lang=js&"
export * from "./AaddNews.vue?vue&type=script&lang=js&"
import style0 from "./AaddNews.vue?vue&type=style&index=0&id=1c67ad5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67ad5e",
  null
  
)

export default component.exports